var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaderData.active)?_c('v-progress-linear',{attrs:{"active":_vm.loaderData.show,"indeterminate":_vm.loaderData.query,"query":_vm.loaderData.query},model:{value:(_vm.loaderData.value),callback:function ($$v) {_vm.$set(_vm.loaderData, "value", $$v)},expression:"loaderData.value"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }